interface RoundChargeableWeight {
  productType: string;
  rule: number;
  chargeableWeight: number;
  ruleKey?: string;
}

const convertByRules = (fractionRule = 0.31, weightNumber = 0) => {
  const fraction = weightNumber % 1;

  if (Number(fraction.toFixed(2)) >= fractionRule) {
    return Math.ceil(weightNumber);
  }

  return Math.floor(weightNumber);
};

const convertRound0point5 = ({ chargeableWeight }: RoundChargeableWeight) =>
  Math.ceil(chargeableWeight * 2) / 2;

const roundMalaysiaZeroPointFive = (chargeableWeight: number) =>
  Math.ceil(chargeableWeight * 2) / 2;

export const getRoundedChargeableWeightByRules = (
  params: RoundChargeableWeight
): number => {
  const { productType, rule, chargeableWeight, ruleKey } = params;

  if (ruleKey === "rules-0.5-my") {
    return Math.max(0.5, roundMalaysiaZeroPointFive(chargeableWeight));
  }

  if (ruleKey === "rules-0.1-my") {
    return Math.max(0.1, Math.ceil(chargeableWeight * 10) / 10);
  }

  const is0point5 =
    productType.match(/INTERPACK|INTERPACKMAXI/gi) && rule === 0.5;

  if (is0point5) {
    return Math.max(1, convertRound0point5(params));
  }

  return Math.max(1, convertByRules(rule, chargeableWeight));
};
